var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFishs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.7 66.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .6;\n      }\n\n      .cls-2 {\n        fill: #8af3e5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.45,2.09c.51,.63-.65,.81-2.58,.41-1.93-.4-3.91-1.24-4.42-1.87-.51-.63,.65-.81,2.58-.41,1.93,.4,3.91,1.24,4.42,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.34,27.78c.51,.63-.65,.81-2.58,.41-1.93-.4-3.91-1.24-4.42-1.87-.51-.63,.65-.81,2.58-.41,1.93,.4,3.91,1.24,4.42,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.21,58.52c.51,.63-.65,.81-2.58,.41-1.93-.4-3.91-1.24-4.42-1.87-.51-.63,.65-.81,2.58-.41,1.93,.4,3.91,1.24,4.42,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.41,55.74c.51,.63-.65,.81-2.58,.41-1.93-.4-3.91-1.24-4.42-1.87-.51-.63,.65-.81,2.58-.41,1.93,.4,3.91,1.24,4.42,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.14,35.73c.51,.63-.65,.81-2.58,.41-1.93-.4-3.91-1.24-4.42-1.87-.51-.63,.65-.81,2.58-.41,1.93,.4,3.91,1.24,4.42,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.14,9.08c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.93,20.46c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.27,35.6c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.89,60.43c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.98,22.55c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.71,48.94c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.49,54.63c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.54,66.18c.51,.63-.19,.91-1.57,.62-1.37-.29-2.9-1.03-3.4-1.66-.51-.63,.19-.91,1.57-.62,1.37,.29,2.9,1.03,3.4,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.03,8.29c.6,.75-.68,.99-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.82,49.2c.6,.75-.68,.98-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.33,33.13c.6,.75-.68,.98-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.26,19.26c.6,.75-.68,.99-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.44,41.63c.6,.75-.68,.99-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.98,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.71,58.5c.6,.75-.68,.98-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.22,43.32c.6,.75-.68,.99-2.87,.53s-4.45-1.43-5.05-2.18c-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.08,30.03c.6,.75-.68,.99-2.87,.53-2.19-.46-4.45-1.43-5.05-2.18-.6-.75,.68-.99,2.87-.53,2.19,.46,4.45,1.43,5.05,2.18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishs);
export default __webpack_public_path__ + "static/media/fishs.c5a5b0815bf79bb7965edfa269c87d38.svg";
export { ForwardRef as ReactComponent };